import React, { useEffect, useState } from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import { useParams } from "react-router-dom";
import Translator from '../../../../../components/helpers/Translator';
import AppSpinner from '../../../../../components/AppSpinner';
import colors from '../../../../../../constants/colors';
import { axiosPath } from '../../../../../../routing/helpers/router';
import errorHandler from '../../../../../components/error/ErrorHandler';

export default function GGCLFavouriteObligation(props) {
  const { isFavourite, obligationID } = props;
  const dispatch = useDispatch();
  const { moduleBridgeHex, plantHex } = useParams();
  const [favourite, setFavourite] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (favourite === undefined) setFavourite(isFavourite);
  }, [isFavourite]);

  // > CHANGE FAVOURITE
  const changeFavourite = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_globalLegalCompliance_evaluation_setFavouriteObligation"
        ),
        { moduleBridgeHex, plantHex, obligationID }
      );
      setIsLoading(false);
      setFavourite(response.data);
    } catch (err) {
      setIsLoading(false);
      dispatch(errorHandler(err, history));
    }
  };
  // < CHANGE FAVOURITE

  if (isLoading) {
    return (
      <AppSpinner>
        <AppRemixIcon icon="loader-4" color={colors.primary} />
      </AppSpinner>
    );
  }

  return (
    <AppRemixIcon
      icon="star"
      title={ReactDOMServer.renderToString(
        <Translator file="module-legalCompliance" name="mark.favourite" />
      )}
      color={favourite ? colors.danger : colors.grey300}
      filled={favourite}
      className="pointer"
      onClick={isFavourite !== undefined ? () => changeFavourite() : () => {}}
    />
  );
}
